
export const LANGS = [
  { value : "de", label: "Deutsch" },
  { value : "en", label: "English" },
  { value : "es", label: "Español" },
  { value : "fr", label: "Français" },
  { value : "ru", label: "Русский" },
  { value : "zh-CN", label: "中文(简体)" },
  { value : "zh-TW", label: "中文(繁體)" },
  { value : "ja", label: "日本語" },
  { value : "ko", label: "한국어" },
];

